import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/src/entities/gallery/ui/FastMarque/FastMarque.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/src/entities/gallery/ui/Gallery/Gallery.scss");
;
import(/* webpackMode: "eager" */ "/app/src/src/entities/game/ui/Games/Games.scss");
;
import(/* webpackMode: "eager" */ "/app/src/src/entities/partner/ui/Partners/Partners.scss");
;
import(/* webpackMode: "eager" */ "/app/src/src/entities/event/ui/Event/Event.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/src/entities/partner/ui/PartnersFastMarquee/PartnersFastMarquee.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/src/entities/social/images/socials-sprite.png");
;
import(/* webpackMode: "eager" */ "/app/src/src/entities/social/ui/Socials/Socials.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/src/features/show-feedback-modal/ui/ShowModalButton/ShowModalButton.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/src/shared/images/elf/back_ice.png");
;
import(/* webpackMode: "eager" */ "/app/src/src/shared/images/elf/back_mobile_ice.png");
;
import(/* webpackMode: "eager" */ "/app/src/src/shared/images/elf/green_stone.png");
;
import(/* webpackMode: "eager" */ "/app/src/src/shared/images/elf/violet_stone.png");
;
import(/* webpackMode: "eager" */ "/app/src/src/shared/images/elf/yellow_stone.png");
;
import(/* webpackMode: "eager" */ "/app/src/src/shared/images/mascots/sigma-logo.png");
;
import(/* webpackMode: "eager" */ "/app/src/src/shared/images/v3/css_sprites_compr.png");
;
import(/* webpackMode: "eager" */ "/app/src/src/shared/ui/Text/Text.scss");
;
import(/* webpackMode: "eager" */ "/app/src/src/shared/ui/Icon/Icon.scss");
;
import(/* webpackMode: "eager" */ "/app/src/src/widgets/AdventureIntro/ui/Intro/assets/adventureBg.png");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/src/widgets/Cleopatra/ui/CleopatraContent/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/src/widgets/Cleopatra/ui/Intro/Intro.scss");
;
import(/* webpackMode: "eager" */ "/app/src/src/widgets/Elf/ui/Intro/Intro.scss");
;
import(/* webpackMode: "eager" */ "/app/src/src/widgets/Events/ui/Events/Events.scss");
;
import(/* webpackMode: "eager" */ "/app/src/src/shared/ui/Title/Title.scss");
;
import(/* webpackMode: "eager" */ "/app/src/src/widgets/AdventureIntro/ui/Intro/Intro.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/src/widgets/FeedbackForm/ui/FeedbackForm/FeedbackForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/src/widgets/Fisher/ui/FisherContent/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/src/widgets/Fisher/ui/Intro/Intro.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/src/widgets/Fisher/ui/ParallaxSprite/ParallaxSprite.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/src/widgets/IgamingHobbies/ui/IgamingHobbies.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/src/widgets/Magic/ui/Intro/Intro.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/src/widgets/Magic/ui/MagicContent/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/src/widgets/Mascots/ui/Intro/Intro.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/src/widgets/Mascots/ui/MascotsContent/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/src/widgets/Mummy/ui/Intro/Intro.scss");
;
import(/* webpackMode: "eager" */ "/app/src/src/entities/person/ui/Person/Person.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/src/widgets/Mummy/ui/MummyContent/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/src/widgets/Persons/ui/Persons/Persons.scss");
;
import(/* webpackMode: "eager" */ "/app/src/src/widgets/Stand/ui/Stand/Stand.scss");
